const SERVING_INSTRUCTIONS = {
  SERVE: 'readyToServe',
  HEAT: 'requiresHeating',
  COOK: 'requiresCooking',
  HEAT_OR_SERVE: 'serveHotOrCold',
};

export default SERVING_INSTRUCTIONS;
